/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import Picture from 'components/Picture/Picture';
import useAnimation from './animations';
import './Next.scss';

const DEFAULT_THUMB: ComponentProps<typeof Picture> = {};

const DEFAULT_LABELS = {
  next: 'Next story',
  more: 'Read more',
};

const DEFAULT_ON_NAVIGATE = () => {};

interface NextProps {
  url: string;
  title?: string;
  thumb?: ComponentProps<typeof Picture>;
  labels?: { next: string; more: string };
  onNavigate?: (url: string) => void;
}

/**
 * This is the Next component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Next({
  url,
  title = '',
  thumb = DEFAULT_THUMB,
  labels = DEFAULT_LABELS,
  onNavigate = DEFAULT_ON_NAVIGATE,
}: NextProps) {
  const ref = useAnimation<HTMLDivElement>();

  return (
    <div ref={ref} className="next-entry">
      <button
        onClick={() => {
          onNavigate(url);
        }}
      >
        <div>
          <div className="thumb">
            <div>
              <Picture {...thumb} />
            </div>
          </div>
          <div className="text">
            <small className="category">{labels.next}</small>
            <h2 appear-text="true">{title}</h2>
            <div className="more">
              <span>{labels.more}</span>
              <svg
                width="18"
                height="8"
                viewBox="0 0 18 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.3536 4.35355C17.5488 4.15829 17.5488 3.84171 17.3536 3.64645L14.1716 0.464466C13.9763 0.269204 13.6597 0.269204 13.4645 0.464466C13.2692 0.659728 13.2692 0.976311 13.4645 1.17157L16.2929 4L13.4645 6.82843C13.2692 7.02369 13.2692 7.34027 13.4645 7.53553C13.6597 7.7308 13.9763 7.7308 14.1716 7.53553L17.3536 4.35355ZM0 4.5H17V3.5H0V4.5Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}

export default Next;
